import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ComponentUtilsService } from '@core/services';
import {
  customComponentListener,
  onFormFieldChangeType,
  textInputConfig,
} from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime } from 'rxjs';

@Component({
  imports: [TranslateModule, ReactiveFormsModule],
  standalone: true,
  selector: 'text-input-component',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
})
export class CustomTextInputComponent {
  @Input({ required: true }) config!: textInputConfig;
  @Input({ required: false }) listeners!: customComponentListener[];

  protected textInputControl = new FormControl();

  @Input()
  set value(val: any) {    
    this.textInputControl.setValue(val, { emitEvent: false });
  }

  @Output() onFormFieldChange: EventEmitter<onFormFieldChangeType> =
    new EventEmitter<onFormFieldChangeType>();

  constructor(private utils: ComponentUtilsService) {}

  ngOnInit() {
    this.utils.attachListeners(this, this.listeners);

    this.textInputControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe(this.setValue.bind(this));

    if (this.config.disabled) this.textInputControl.disable();

    if (this.config.value) this.textInputControl.setValue(this.config.value);
  }

  setValue(value: any) {    
    if (value == undefined) return;

    this.onFormFieldChange.emit({
      field: this.config.fieldName,
      value: value.length > 0 ? value : undefined,
    });
  }
}
